module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ded"
    }
  }, [_c('p', {
    staticClass: "dedf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.v"
    }
  }), _vm._v("To")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("David H. Wallace")]), _vm._v(" "), _c('p', {
    staticClass: "dedf"
  }, [_vm._v("and")]), _vm._v(" "), _c('p', {
    staticClass: "dedf"
  }, [_vm._v("the Memory of")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Robert B. Laurin (1927–77)")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("Christian Gentlemen")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("and Scholars, Both")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21bcfc2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-nicot04nu-0004.vue
// module id = 63
// module chunks = 0